import { COLOR } from '@nxt-insurance/ui-kit/constants'

import type { SvgProps } from './types'

const Medium = (props: SvgProps) => {
  const fill = COLOR[props.color]

  return (
    <svg height="16px" width="16px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <g id="medium" fill={fill}>
        <path d="M29.413,23.249c-0.844-0.001-1.548-3.168-1.55-7.234c-0.002-4.069,0.7-7.268,1.551-7.266   c0.858,0.002,1.551,3.252,1.549,7.265C30.961,20.034,30.266,23.245,29.413,23.249z" />
        <path d="M22.999,24.05c-2.37,0-4.345-3.517-4.35-8.032C18.643,11.499,20.613,7.948,23,7.95   c2.408,0.002,4.354,3.61,4.348,8.066C27.342,20.48,25.393,24.046,22.999,24.05z" />
        <path d="M9.517,24.48c-4.62,0-8.47-3.705-8.48-8.462c-0.01-4.76,3.831-8.501,8.484-8.499   c4.694,0.002,8.489,3.804,8.477,8.498C17.985,20.72,14.184,24.477,9.517,24.48z" />
      </g>
    </svg>
  )
}
export default Medium
